export enum BookmarkViewModeTag {
  All = '',
  Quiz = 'mode-quiz',
  Content = 'mode-content',
}
